export default {
  label: {
    scale: 'Response Scale',
    chooseScale: 'Select Response Scale',
    inheritCompany: 'Use Parent Company Settings',
    scaleChineseDescription: 'Response Scale Description CN',
    scaleEnglishDescription: 'Response Scale Description EN',
    scorePoint: '{score} Points',
    point: '{score} point'
  },
  message: {
    confirmUseParentCompanyConfig: 'Please confirm to use parent company settings?',
    confirmCancelParentCompanyConfig: 'Please confirm not to use parent company settings?'
  }
}
